import {
  COMPLIANCE_LABEL_COLORS,
  MATERIAL_TEXT_COLOR,
  VISIT_COLORS,
  VISIT_TEXT_COLORS,
} from './charts';
import { NAVY, SLATE_DARK } from './palette';

/**
 * Single source of the state colors on the map: pins and legend swatches read
 * these constants, and the SCSS receives them as CSS variables set from React
 * (see `stateColorVars`). The state TEXT in the popup is the exception: it
 * uses `VISIT_TEXT_COLORS` (text-safe shades, e.g. a dark Amber), not these
 * fill colors. Fixed on purpose, never from `colorPrimary`.
 */
export const MAP_STATE_COLORS = {
  executed: VISIT_COLORS.executed,
  incident: VISIT_COLORS.incident,
  pending: VISIT_COLORS.pending,
} as const;

/**
 * Neutral grey for a van with no assigned palette color. It is a placeholder,
 * not a state: it carries no executed/incident/pending meaning.
 */
export const FALLBACK_VAN_COLOR = '#8c8c8c';

/** The legend swatch of "executed": a pin is filled with its route color. */
export const EXECUTED_LEGEND_COLOR = SLATE_DARK;

/** CSS variables consumed by `VisitHistory.scss` (legend swatches). */
export const stateColorVars = {
  '--vh-executed': MAP_STATE_COLORS.executed,
  '--vh-executed-swatch': EXECUTED_LEGEND_COLOR,
  '--vh-incident': MAP_STATE_COLORS.incident,
  '--vh-pending': MAP_STATE_COLORS.pending,
} as Record<string, string>;

/**
 * Palette variables for the whole view, published on its root from React so
 * the SCSS holds no color literal of its own (same idea as `--rr-*`).
 */
export const visitPaletteVars = {
  '--vh-title': NAVY,
  '--vh-hover': NAVY,
  '--vh-executed-text': VISIT_TEXT_COLORS.executed,
  '--vh-incident-text': VISIT_TEXT_COLORS.incident,
  '--vh-material-text': MATERIAL_TEXT_COLOR,
  '--vh-bad-text': COMPLIANCE_LABEL_COLORS.bad,
  '--vh-warn-text': COMPLIANCE_LABEL_COLORS.warn,
  '--vh-ok-text': COMPLIANCE_LABEL_COLORS.ok,
  ...stateColorVars,
} as Record<string, string>;
